module.exports = __webpack_public_path__ + "static/media/UI_Select_Screen.fac5d5c4.jpg";